import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

export type Data = RaidbossData;

const triggerSet: TriggerSet<Data> = {
  id: 'DohnMheg',
  zoneId: ZoneId.DohnMheg,
  timelineFile: 'dohn_mheg.txt',
  timelineTriggers: [
    {
      id: 'Dohn Mheg Rake',
      regex: /Rake/,
      beforeSeconds: 5,
      response: Responses.miniBuster(),
    },
  ],
  triggers: [
    {
      id: 'Dohn Mheg Watering Wheel',
      type: 'StartsUsing',
      // TODO: double check this with an import, is there a The??
      netRegex: { id: '3DAA', source: 'Dohnfast Fuath' },
      condition: (data) => data.CanSilence(),
      response: Responses.interrupt(),
    },
    {
      id: 'Dohn Mheg Straight Punch',
      type: 'StartsUsing',
      // TODO: double check this with an import, is there a The??
      netRegex: { id: '3DAB', source: 'Dohnfast Basket' },
      condition: (data) => data.CanStun(),
      response: Responses.stun('info'),
    },
    {
      id: 'Dohn Mheg Proboscis',
      type: 'StartsUsing',
      // TODO: double check this with an import, is there a The??
      netRegex: { id: '3DAF', source: 'Dohnfast Etainmoth' },
      condition: (data) => data.CanStun(),
      response: Responses.stun('info'),
    },
    {
      id: 'Dohn Mheg Torpedo',
      type: 'StartsUsing',
      // TODO: double check this with an import, is there a The??
      netRegex: { id: '3DB5', source: 'Dohnfast Kelpie' },
      condition: (data) => data.CanStun(),
      response: Responses.stun('info'),
    },
    {
      id: 'Dohn Mheg Candy Cane',
      type: 'StartsUsing',
      netRegex: { id: '2299', source: 'Aenc Thon, Lord Of The Lingering Gaze' },
      response: Responses.tankBuster(),
    },
    {
      id: 'Dohn Mheg Landsblood',
      type: 'StartsUsing',
      netRegex: { id: '1E8E', source: 'Aenc Thon, Lord Of The Lingering Gaze', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Dohn Mheg Leap Stack',
      type: 'HeadMarker',
      netRegex: { id: '003E' },
      response: Responses.stackMarkerOn(),
    },
    {
      id: 'Dohn Mheg Timber',
      type: 'StartsUsing',
      netRegex: { id: '22D3', source: 'Griaule', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Dohn Mheg Crippling Blow',
      type: 'StartsUsing',
      netRegex: { id: '35A4', source: 'Aenc Thon, Lord Of The Lengthsome Gait' },
      response: Responses.tankBuster(),
    },
    {
      id: 'Dohn Mheg Imp Choir',
      type: 'StartsUsing',
      netRegex: { id: '34F0', source: 'Aenc Thon, Lord Of The Lengthsome Gait', capture: false },
      response: Responses.lookAway('alert'),
    },
    {
      id: 'Dohn Mheg Toad Choir',
      type: 'StartsUsing',
      netRegex: { id: '34EF', source: 'Aenc Thon, Lord Of The Lengthsome Gait', capture: false },
      response: Responses.awayFromFront(),
    },
    {
      id: 'Dohn Mheg Virtuosic Cappriccio',
      type: 'StartsUsing',
      netRegex: { id: '358C', source: 'Aenc Thon, Lord Of The Lengthsome Gait', capture: false },
      response: Responses.aoe(),
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Teag Gye': 'Taeg Gye',
        'The Atelier': 'Griaules Revier',
        'The throne room': 'Garten des Kronsaal',
        'Aenc Thon, Lord of the Lingering Gaze':
          'Aenc Thon (?:der|die|das) Glupschäugig(?:e|er|es|en)',
        'Griaule': 'Griaule',
        'Painted Sapling': 'Griaules Sämling',
        'Aenc Thon, Lord of the Lengthsome Gait':
          'Aenc Thon (?:der|die|das) Langbeinig(?:e|er|es|en)',
        'Shade of Fear': 'Schatten der Angst',
        'Dohnfast Fuath': 'Dohn-Fuath',
        'Dohnfast Basket': 'Dohn-Blumenkorb',
        'Dohnfast Etainmoth': 'Dohn-Edianmotte',
        'Dohnfast Kelpie': 'Dohn-Kelpie',
      },
      'replaceText': {
        'Swinge': 'Brutaler Odem',
        'Fodder': 'Hungriges Gebrüll',
        'Tiiimbeeer': 'Baum fääällt',
        'Feeding Time': 'Fütterungszeit',
        'Coiling Ivy': 'Verschlungener Efeu',
        'Crippling Blow': 'Verkrüppelnder Schlag',
        'Imp Choir': 'Koboldchor',
        'Corrosive Bile': 'Ätzende Galle',
        'Geyser': 'Geysir',
        'Hydrofall': 'Hydro-Sturz',
        'Laughing Leap': 'Freudensprung',
        'Landsblood': 'Erdblut',
        'Candy Cane': 'Quietschehammer',
        'Funambulist\'s Fantasia': 'Seiltanz-Fantasie',
        'Malaise': 'Malaise',
        'Bile Bombardment': 'Galliger Niederschlag',
        'Flailing Tentacles': 'Tentakelflegel',
        'Toad Choir': 'Froschchor',
        'Changeling\'s Fantasia': 'Wechselbalg-Fantasie',
        'Virtuosic Capriccio': 'Virtuoses Capriccio',
        'Rake': 'Prankenhieb',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        'Aenc Thon, Lord of the Lengthsome Gait': 'Aenc Thon Le Virtuose',
        'Aenc Thon, Lord of the Lingering Gaze': 'Aenc Thon L\'Envoûtant',
        'Griaule': 'Griaule',
        'Painted Sapling': 'Pousse de Griaule',
        'Shade of Fear': 'Illusion terrifiante',
        'Teag Gye': 'la Teag Gye',
        'The Atelier': 'Repos de Griaule',
        'The throne room': 'la salle du trésor',
        'Dohnfast Fuath': 'Fuath de Dohn Mheg',
        'Dohnfast Basket': 'panier de Dohn Mheg',
        'Dohnfast Etainmoth': 'noctuétain de Dohn Mheg',
        'Dohnfast Kelpie': 'kelpie de Dohn Mheg',
      },
      'replaceText': {
        'Bile Bombardment': 'Bombardement bilieux',
        'Candy Cane': 'Canne en sucre d\'orge',
        'Changeling\'s Fantasia': 'Fantaisie du changelin',
        'Coiling Ivy': 'Étreinte de lierre',
        'Corrosive Bile': 'Bile corrosive',
        'Crippling Blow': 'Coup handicapant',
        'Feeding Time': 'Moisson',
        'Flailing Tentacles': 'Tentacules flagellants',
        'Fodder': 'Culture',
        'Funambulist\'s Fantasia': 'Fantaisie du funambule',
        'Geyser': 'Geyser',
        'Hydrofall': 'Pilonnage hydrique',
        'Imp Choir': 'Mélodie du kappa',
        'Landsblood': 'Pulsation phréatique',
        'Laughing Leap': 'Bond soudain',
        'Malaise': 'Malaise',
        'Rake': 'Griffes',
        'Swinge': 'Brutalité',
        'Tiiimbeeer': 'Ça tooombe',
        'Toad Choir': 'Mélodie du crapeau',
        'Virtuosic Capriccio': 'Capriccio effréné',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Aenc Thon, Lord of the Lengthsome Gait': '楽聖のインク＝ゾン',
        'Aenc Thon, Lord of the Lingering Gaze': '美眼のインク＝ゾン',
        'Griaule': 'グリオール',
        'Painted Sapling': 'グリオール・サップリング',
        'Shade of Fear': '恐怖の幻影',
        'Teag Gye': '微睡みの泉',
        'The Atelier': 'グリオールの寝床',
        'The throne room': '王冠の間',
        'Dohnfast Fuath': 'ドォーヌ・フーア',
        'Dohnfast Basket': 'ドォーヌ・バスケット',
        'Dohnfast Etainmoth': 'ドォーヌ・エーディンモス',
        'Dohnfast Kelpie': 'ドォーヌ・ケルピー',
      },
      'replaceText': {
        'Bile Bombardment': '蟲毒飛散',
        'Candy Cane': 'キャンディケーン',
        'Changeling\'s Fantasia': '自己変異のファンタジア',
        'Coiling Ivy': '絡みつく蔦',
        'Corrosive Bile': 'コロシヴバイル',
        'Crippling Blow': '痛打',
        'Feeding Time': '養分献上',
        'Flailing Tentacles': '蠢く触手',
        'Fodder': '養分召喚',
        'Funambulist\'s Fantasia': '一本橋のファンタジア',
        'Geyser': '噴出',
        'Hydrofall': 'ハイドロフォール',
        'Imp Choir': 'カッパの調べ',
        'Landsblood': '水脈乱打',
        'Laughing Leap': '飛びかかり',
        'Malaise': '蟲毒瘴',
        'Rake': 'ひっかき',
        'Swinge': 'スイング',
        'Tiiimbeeer': 'ティーンバー',
        'Toad Choir': 'カエルの調べ',
        'Virtuosic Capriccio': '苛烈なるカプリッチョ',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Teag Gye': '선잠의 샘',
        'The Atelier': '그리올의 침상',
        'The throne room': '왕관의 방',
        'Aenc Thon, Lord of the Lingering Gaze': '눈이 예쁜 잉크 돈',
        'Griaule': '그리올',
        'Painted Sapling': '그리올 묘목',
        'Aenc Thon, Lord of the Lengthsome Gait': '대음악가 잉크 돈',
        'Shade of Fear': '공포의 환영',
        'Dohnfast Fuath': '도느 푸아',
        'Dohnfast Basket': '도느 바구니',
        'Dohnfast Etainmoth': '도느 에다인나방',
        'Dohnfast Kelpie': '도느 켈피',
      },
      'replaceText': {
        'Swinge': '징벌',
        'Fodder': '양분 소환',
        'Tiiimbeeer': '쓰러진다아아',
        'Feeding Time': '양분 헌상',
        'Coiling Ivy': '휘감는 덩굴',
        'Crippling Blow': '통타',
        'Imp Choir': '물요정의 음률',
        'Corrosive Bile': '부식성 담즙',
        'Geyser': '분출',
        'Hydrofall': '물 쏟기',
        'Laughing Leap': '달려들기',
        'Landsblood': '수맥 난타',
        'Candy Cane': '막대사탕',
        'Funambulist\'s Fantasia': '외나무다리 환상곡',
        'Malaise': '벌레독',
        'Bile Bombardment': '벌레독 살포',
        'Flailing Tentacles': '꿈틀대는 촉수',
        'Toad Choir': '개구리의 음률',
        'Changeling\'s Fantasia': '자기 변이 환상곡',
        'Virtuosic Capriccio': '가열찬 광상곡',
        'Rake': '할퀴기',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Teag Gye': '微睡之泉',
        'The Atelier': '格里奥勒的睡床',
        'The throne room': '王冠之间',
        'Aenc Thon, Lord of the Lingering Gaze': '美眼 因克·佐恩',
        'Griaule': '格里奥勒',
        'Painted Sapling': '格里奥勒花苗',
        'Aenc Thon, Lord of the Lengthsome Gait': '乐圣 因克·佐恩',
        'Shade of Fear': '恐怖幻影',
        'Dohnfast Fuath': '禁园水妖',
        'Dohnfast Basket': '禁园篮筐',
        'Dohnfast Etainmoth': '禁园爱蒂恩蛾',
        'Dohnfast Kelpie': '禁园凯尔派',
      },
      'replaceText': {
        'Swinge': '重击',
        'Fodder': '召唤养分',
        'Tiiimbeeer': '震木',
        'Feeding Time': '献上养分',
        'Coiling Ivy': '缠绕藤蔓',
        'Crippling Blow': '痛击',
        'Imp Choir': '河童歌唱队',
        'Corrosive Bile': '腐蚀咬',
        'Geyser': '幻水泉',
        'Hydrofall': '水瀑',
        'Laughing Leap': '飞扑',
        'Landsblood': '水脉乱打',
        'Candy Cane': '糖果手杖',
        'Funambulist\'s Fantasia': '独木桥幻想曲',
        'Malaise': '虫毒瘴',
        'Bile Bombardment': '虫毒飞散',
        'Flailing Tentacles': '触手轰击',
        'Toad Choir': '青蛙歌唱队',
        'Changeling\'s Fantasia': '自身变异幻想曲',
        'Virtuosic Capriccio': '残酷狂想曲',
        'Rake': '利爪',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Teag Gye': '微睡之泉',
        'The Atelier': '格里奧勒的睡床',
        'The throne room': '王冠之間',
        'Aenc Thon, Lord of the Lingering Gaze': '美眼 因克·佐恩',
        'Griaule': '格里奧勒',
        'Painted Sapling': '格里奧勒花苗',
        'Aenc Thon, Lord of the Lengthsome Gait': '樂聖 因克·佐恩',
        'Shade of Fear': '恐怖幻影',
        'Dohnfast Fuath': '禁園水妖',
        'Dohnfast Basket': '禁園籃筐',
        'Dohnfast Etainmoth': '禁園愛蒂恩蛾',
        'Dohnfast Kelpie': '禁園凱爾派',
      },
      'replaceText': {
        'Swinge': '重擊',
        'Fodder': '召喚養分',
        'Tiiimbeeer': '震木',
        'Feeding Time': '獻上養分',
        'Coiling Ivy': '纏繞藤蔓',
        'Crippling Blow': '痛擊',
        'Imp Choir': '河童歌唱隊',
        'Corrosive Bile': '腐蝕咬',
        'Geyser': '幻水泉',
        'Hydrofall': '水瀑',
        'Laughing Leap': '飛撲',
        'Landsblood': '水脈亂打',
        'Candy Cane': '糖果手杖',
        'Funambulist\'s Fantasia': '獨木橋幻想曲',
        'Malaise': '蟲毒瘴',
        'Bile Bombardment': '蟲毒飛散',
        'Flailing Tentacles': '觸手轟擊',
        'Toad Choir': '青蛙歌唱隊',
        'Changeling\'s Fantasia': '自身變異幻想曲',
        'Virtuosic Capriccio': '殘酷狂想曲',
        'Rake': '利爪',
      },
    },
  ],
};

export default triggerSet;
